const mergeLists = (parsedDoc: Document, listTag: string) => {
  const lists = parsedDoc.querySelectorAll(listTag)
  let continueMerging = true

  while (continueMerging) {
    continueMerging = false

    lists.forEach((list) => {
      const nextElement = list.nextElementSibling

      if (nextElement?.tagName.toLowerCase() === listTag) {
        const elementClasses = Array.from(list.classList)
        const nextElementClasses = Array.from(nextElement.classList)
        const elementListClasses = elementClasses.filter((elementClass) =>
          elementClass.startsWith(listTag === 'ol' ? 'NumberListStyle' : 'BulletListStyle')
        )
        const nextElementListClasses = nextElementClasses.filter((elementClass) =>
          elementClass.startsWith(listTag === 'ol' ? 'NumberListStyle' : 'BulletListStyle')
        )

        if (elementListClasses.length > 0 && nextElementListClasses.length > 0) {
          const isClassesEqual = elementListClasses.every((elementClass) =>
            nextElementListClasses.includes(elementClass)
          )

          if (isClassesEqual) {
            while (nextElement.firstChild) {
              list.appendChild(nextElement.firstChild)
            }
            nextElement.remove()
            continueMerging = true
          }
        }
      }
    })
  }
}

const preparingNestedLists = (lists: NodeListOf<Element>) => {
  lists.forEach((list) => {
    const listItems = list.querySelectorAll('li')
    let foundHigherLevel = false
    let currentAriaLevelNumber = 0

    listItems.forEach((item) => {
      const ariaLevel = item.getAttribute('data-aria-level')
      if (ariaLevel) {
        const ariaLevelNumber = parseInt(ariaLevel, 10)
        if (ariaLevelNumber > 1) {
          foundHigherLevel = true
          currentAriaLevelNumber = ariaLevelNumber
        }
      }
    })

    if (foundHigherLevel) {
      const previousElement = list.previousElementSibling
      let validPreviousList = false

      if (previousElement) {
        if (previousElement.matches('ul, ol')) {
          const prevListItems = previousElement.querySelectorAll('li')
          prevListItems.forEach((prevItem) => {
            const prevAriaLevel = prevItem.getAttribute('data-aria-level')
            if (prevAriaLevel) {
              const prevAriaLevelNumber = parseInt(prevAriaLevel, 10)
              if (prevAriaLevelNumber === currentAriaLevelNumber - 1) {
                validPreviousList = true
              }
            }
          })
          if (validPreviousList) {
            const validItems = Array.from(previousElement.querySelectorAll('li')).filter((item) => {
              const prevAriaLevel = item.getAttribute('data-aria-level')
              if (prevAriaLevel) {
                const prevAriaLevelNumber = parseInt(prevAriaLevel, 10)
                return prevAriaLevelNumber === currentAriaLevelNumber - 1
              }
              return false
            })

            if (validItems.length > 0) {
              const lastValidItem = validItems[validItems.length - 1]
              const wrapperLi = document.createElement('li')
              wrapperLi.appendChild(list)
              lastValidItem.insertAdjacentElement('afterend', wrapperLi)
            }
          }
        }
      }
    }
  })
}

const preparingListIndents = (lists: NodeListOf<Element>) => {
  lists.forEach((list) => {
    const listItems = list.querySelectorAll(':scope > li')

    let foundMarginLeft = ''
    listItems.forEach((item) => {
      const marginLeft = (item as HTMLElement).style.marginLeft
      if (marginLeft) {
        foundMarginLeft = marginLeft
        ;(item as HTMLElement).style.marginLeft = ''
      }
    })

    if (foundMarginLeft) {
      ;(list as HTMLElement).style.marginLeft = foundMarginLeft
    }
  })
}

export const prepareListsFromOtherEditors = (parsedDoc: Document) => {
  // remove extra divs that wrap numbered lists
  const listContainerElements = parsedDoc.querySelectorAll('.ListContainerWrapper')
  listContainerElements.forEach((listContainerElement) => {
    const fragment = document.createDocumentFragment()
    while (listContainerElement.firstChild) {
      fragment.appendChild(listContainerElement.firstChild)
    }
    listContainerElement.parentNode?.replaceChild(fragment, listContainerElement)
  })

  // when copied from Word, each element of a list comes wrapped in a separate list; for correct use,
  // we must group them and wrap the corresponding elements in our own list
  mergeLists(parsedDoc, 'ol')
  mergeLists(parsedDoc, 'ul')

  const lists = parsedDoc.querySelectorAll('ul, ol')
  lists.forEach((listElement) => {
    const children = Array.from(listElement.children)
    children.forEach((currentElement, index) => {
      const previousElement = index > 0 ? children[index - 1] : null
      if (currentElement.tagName === 'UL' || currentElement.tagName === 'OL') {
        if (previousElement && previousElement.tagName === 'LI') {
          previousElement.appendChild(currentElement)
        } else {
          const liElement = document.createElement('li')
          currentElement.parentNode?.appendChild(liElement)
          liElement.appendChild(currentElement)
        }
      }
    })
  })

  // When copied from word, lists lose their nesting. This method returns nesting
  preparingNestedLists(lists)

  preparingListIndents(lists)
}
